import React from "react";
import NotificationPageSection from "../../Sections/NotificationPageSection/Content";
const NotificationPage = () => {
  return <NotificationPageSection />;
};

export default NotificationPage;
